import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import SSO from '@reddotpay/rdp-sso';
import Loading from "@/components/Loading.vue";
import Paging from '@/components/Paging';
// import VueSidebarMenu from "vue-sidebar-menu";
import VeeValidate from "vee-validate";


Vue.use(VeeValidate);
Vue.use(VueAxios, axios);
// Vue.use(VueSidebarMenu);
Vue.component('tt-loading', Loading);
Vue.component('tt-paging', Paging);

Vue.config.productionTip = false;

export const eventBus = new Vue();

Object.defineProperty(Vue.prototype, '$sso', { value: SSO });

router.beforeEach((to, from, next) => {
    // this line of code is to handle the hashed url properly, since we are not using history mode
    if (window.location.pathname.length >= 2) {
        window.location = `${window.location.origin}/#${window.location.pathname}${window.location.search}`;
    }

    // the entry point for SSO
    // SSO will redirect to optionalDefaultPath after login (/some-path)
    SSO.init(to, from, router);
    next();
});



new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => {
    jQuery('#sidebar').sidebar({
      context: jQuery('#sidebar-context'),
      dimPage: false,
      closable: false,
    }).sidebar('setting', 'transition', 'push page').sidebar('show');

    // Toggle the sidebar by clicking the menu button.
    jQuery('#menu').click(() => {
      jQuery('#sidebar').sidebar({
        context: jQuery('#sidebar-context'),
        dimPage: false,
        closable: false,
      }).sidebar('toggle');
    });

    // check screen size and toggle the sidebar.
    window.addEventListener('resize', () => {
      if (jQuery(window).width() > 768) {
        //do nothing
      } else {
        jQuery('#sidebar').sidebar('hide');
      }
    });
  },
  // start app
}).$mount("#app");



// global.vm = vm;